export const RfidTagStatus = ['UNASSIGNED', 'ASSIGNED', 'EXPIRED', 'LOST'];
